import { render, staticRenderFns } from "./Chile.vue?vue&type=template&id=319a9774&scoped=true&"
import script from "./Chile.vue?vue&type=script&lang=js&"
export * from "./Chile.vue?vue&type=script&lang=js&"
import style0 from "./Chile.vue?vue&type=style&index=0&id=319a9774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a9774",
  null
  
)

export default component.exports